import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { Common } from 'src/domains/common/Common';
import { AccountState } from 'src/domains/players/state/accountState/AccountState';
import { GameDataType } from 'src/domains/casino/state/AppCasino/game-modal/GameData.state';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';

export class ClientCasinoApi {
    constructor(private common: Common) {}

    public startGame(gameData: GameDataType): void {
        const casinoState = AppCasinoState.get(this.common);
        casinoState.gameModalState.startGame(gameData);
    }
}

export class ClientAccountApi {
    constructor(private common: Common) {}

    public refreshAccountData(): void {
        const accountState = AccountState.get(this.common);
        accountState.account?.refreshAll();
    }
}

export class ClientSportsbookApi {
    constructor(private common: Common) {}

    public addSimpleBet(selectionId: number): void {
        // getSelection is deprecated and should be change in the future
        const selectionModel = this.common.models.getSelection(selectionId);
        if (selectionModel === null) {
            console.warn("Selection model not loaded yet; can't add to betslip");
            return;
        }

        const betslipState = AppSportsBookState.get(this.common).betSlipState.betslipData;
        betslipState.onAddSimpleBet(selectionModel.id2);
    }
}

export class ClientApi {
    public readonly casino: ClientCasinoApi;
    public readonly account: ClientAccountApi;
    public readonly sportsbook: ClientSportsbookApi;

    constructor(private common: Common) {
        this.casino = new ClientCasinoApi(this.common);
        this.account = new ClientAccountApi(this.common);
        this.sportsbook = new ClientSportsbookApi(this.common);
    }

    public modalCloseAll(): void {
        const playersState = AppPlayersState.get(this.common);
        playersState.modalState.closeAll();
    }
}
